import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { useAuth } from "../contexts/AuthContext";
import { Package } from "lucide-react";

export default function Profile() {
  const { user } = useAuth();
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    api.get("/orders/mine").then(({ data }) => setOrders(data)).catch(() => {});
  }, []);

  return (
    <div className="max-w-4xl mx-auto px-6 py-16" data-testid="profile-page">
      <div className="text-xs tracking-wider-2 uppercase text-sage mb-3">Account</div>
      <h1 className="font-display text-5xl text-darkRoast">Hi, {user?.name?.split(" ")[0]}.</h1>
      <p className="mt-4 text-earth">{user?.email}</p>

      <h2 className="font-display text-3xl text-darkRoast mt-16 mb-6">Your orders</h2>
      {orders.length === 0 ? (
        <div className="border border-darkRoast/10 p-12 text-center text-earth rounded-sm" data-testid="no-orders">
          <Package className="w-8 h-8 mx-auto mb-3 text-earth/60" strokeWidth={1.5} />
          No orders yet.
        </div>
      ) : (
        <div className="space-y-4">
          {orders.map((o) => (
            <div key={o.order_id} className="border border-darkRoast/10 p-6 rounded-sm" data-testid={`order-${o.order_id}`}>
              <div className="flex flex-wrap justify-between gap-3 mb-3">
                <div>
                  <div className="text-xs tracking-wider-2 uppercase text-earth">Order</div>
                  <div className="font-display text-xl text-darkRoast">#{o.order_id.slice(-8).toUpperCase()}</div>
                </div>
                <div className="text-right">
                  <div className="text-xs tracking-wider-2 uppercase text-earth">{o.payment_status}</div>
                  <div className="font-medium text-darkRoast">${o.total.toFixed(2)}</div>
                </div>
              </div>
              <div className="text-sm text-earth space-y-1">
                {o.items.map((it) => (
                  <div key={it.product_id}>{it.name} × {it.quantity}</div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
